import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyB99aaeyldZb8OYLnz945MUbvojqQ3upyc",
  authDomain: "akarsh-jairaj.firebaseapp.com",
  databaseURL: "https://akarsh-jairaj.firebaseio.com",
  projectId: "akarsh-jairaj",
  storageBucket: "akarsh-jairaj.appspot.com",
  messagingSenderId: "263433922636",
  appId: "1:263433922636:web:0a92d73abf1a3b1624ace9",
  measurementId: "G-RN8VL9QLNB"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };